import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '../../components/ui';
import type { usePurgeSnapshots } from '../../hooks/useSnapshots.js';

interface CleanupSectionProps {
  itemCount: number;
  templateId: number;
  purgeMutation: ReturnType<typeof usePurgeSnapshots>;
  showPurgeConfirm: boolean;
  setShowPurgeConfirm: (v: boolean) => void;
}

export const CleanupSection: React.FC<CleanupSectionProps> = ({
  itemCount,
  templateId,
  purgeMutation,
  showPurgeConfirm,
  setShowPurgeConfirm,
}) => (
  <div className="border-t pt-3 mt-1 px-1">
    <div className="flex items-center gap-2">
      <span className="text-[10px] text-muted">
        {itemCount} snapshot{itemCount !== 1 ? 's' : ''} total
      </span>
      {!showPurgeConfirm ? (
        <Button variant="ghost" size="sm" onClick={() => setShowPurgeConfirm(true)}>
          <Trash2 size={10} /> Purge old
        </Button>
      ) : (
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-warning">Delete unpinned snapshots older than 30 days?</span>
          <Button
            variant="danger"
            size="sm"
            onClick={() => {
              purgeMutation.mutate({ templateId: templateId, unpinnedOnly: true, olderThanDays: 30 });
              setShowPurgeConfirm(false);
            }}
          >
            Confirm
          </Button>
          <Button variant="ghost" size="sm" onClick={() => setShowPurgeConfirm(false)}>
            Cancel
          </Button>
        </div>
      )}
    </div>
    {purgeMutation.isSuccess && purgeMutation.data && (
      <div className="text-[10px] text-success mt-1">
        Deleted {purgeMutation.data.deletedCount ?? purgeMutation.data.deletedCount} snapshot
        {(purgeMutation.data.deletedCount ?? purgeMutation.data.deletedCount) !== 1 ? 's' : ''}
      </div>
    )}
  </div>
);
